import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TasksListParams } from '../api/tasks-resource-method-params';

const DEBUG = true;

@Component({
  selector: 'app-tasks-filter',
  templateUrl: './tasks-filter.component.html',
  styleUrls: ['./tasks-filter.component.scss']
})
export class TasksFilterComponent implements OnInit {

  enableUpdatedSince = this.data.updatedMin ? true : false;
  enableDueRange = (this.data.dueMin||this.data.dueMax) ? true : false;
  enableCompletedRange = (this.data.completedMin||this.data.completedMax) ? true : false;

  form: FormGroup = new FormGroup({
    showHidden: new FormControl(),
    showDeleted: new FormControl(),
    showCompleted: new FormControl(),
    updated: new FormGroup({
      since: new FormControl()
    }),
    due: new FormGroup({
      from: new FormControl(),
      to: new FormControl()
    }),
    completed: new FormGroup({
      from: new FormControl(),
      to: new FormControl()
    }),
  });

  private resetData: Record<string,unknown>;

  constructor(
    public dialogRef: MatDialogRef<TasksFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TasksListParams
  ) {
    if (DEBUG) {console.log('new TaskFilterComponent() with data: %o', data);}
    this.resetData = {
      showHidden: this.data.showHidden ? true : false,
      showDeleted: this.data.showDeleted ? true : false,
      showCompleted: this.data.showCompleted ? true : false,
      updated: {
        since: this.data.updatedMin ? this.data.updatedMin.substr(0,10) : null
      },
      due: {
        from: this.data.dueMin ? this.data.dueMin.substr(0,10) : null,
        to: this.data.dueMax ? this.data.dueMax.substr(0,10) : null
      },
      completed: {
        from: this.data.completedMin ? this.data.completedMin.substr(0,10) : null,
        to: this.data.completedMax ? this.data.completedMax.substr(0,10) : null
      }
    };
    if (DEBUG) {console.log('new TaskFilterComponent() with resetData: %o', data);}
    this.form.setValue(this.resetData);
  }

  // TODO: Restore filter state from session storage
  ngOnInit(): void {
    if (DEBUG) {console.log('TaskFilterComponent onInit()');}

    this.form.get('showHidden')?.valueChanges.subscribe(value => {
      this.data.showHidden = value ? true : undefined;
      if (DEBUG) {console.log('"showHidden" updated to', this.data.showHidden);}
    });
    this.form.get('showCompleted')?.valueChanges.subscribe(value => {
      this.data.showCompleted = value ? true : undefined;
      if (DEBUG) {console.log('"showCompleted" updated to', this.data.showCompleted);}
    });
    this.form.get('showDeleted')?.valueChanges.subscribe(value => {
      this.data.showDeleted = value ? true : undefined;
      if (DEBUG) {console.log('"showDeleted" updated to', this.data.showDeleted);}
    });
    this.form.get('updated')?.get('since')?.valueChanges.subscribe(value => {
      if (value) {
        this.data.updatedMin = new Date(value).toISOString();
        if (DEBUG) {console.log('"updateMin" updated to', this.data.updatedMin);}
      }
      else {
        if (DEBUG) {console.log('"updateMin" unset');}
      }
    });
    this.form.get('due')?.get('from')?.valueChanges.subscribe(value => {
      if (value) {
        this.data.dueMin = new Date(value).toISOString();
        if (DEBUG) {console.log('"dueMin" updated to', this.data.dueMin);}
      }
      else {
        if (DEBUG) {console.log('"dueMin" unset');}
      }
    });
    this.form.get('due')?.get('to')?.valueChanges.subscribe(value => {
      if (value) {
        const date = new Date(value);
        date.setHours(23,59,59);
        this.data.dueMax = date.toISOString();
        if (DEBUG) {console.log('"dueMax" updated to', this.data.dueMax);}
      }
      else {
        if (DEBUG) {console.log('"dueMax" unset');}
      }
    });
    this.form.get('completed')?.get('from')?.valueChanges.subscribe(value => {
      if (value) {
        this.data.completedMin = new Date(value).toISOString();
        if (DEBUG) {console.log('"completedMin" updated to', this.data.completedMin);}
      }
      else {
        if (DEBUG) {console.log('"completedMin" unset');}
      }
    });
    this.form.get('completed')?.get('to')?.valueChanges.subscribe(value => {
      if (value) {
        const date = new Date(value);
        date.setHours(23,59,59);
        this.data.completedMax = date.toISOString();
        if (DEBUG) {console.log('"completedMax" updated to', this.data.completedMax);}
      }
      else {
        if (DEBUG) {console.log('"completedMax" unset');}
      }
    });
  }

  toggleUpdatedFilter(change: MatCheckboxChange): void {
    if (DEBUG) {console.log('TaskFilterComponent toggleUpdatedFilter()', change);}
    this.enableUpdatedSince = change.checked;
    if (change.checked===false) {
      this.data.updatedMin = undefined;
    }
  }

  toggleDueFilter(change: MatCheckboxChange): void {
    if (DEBUG) {console.log('TaskFilterComponent toggleDueFilter()', change);}
    this.enableDueRange = !this.enableDueRange;
    if (change.checked===false) {
      this.data.dueMin = undefined;
      this.data.dueMax = undefined;
    }
  }

  toggleCompletedFilter(change: MatCheckboxChange): void {
    if (DEBUG) {console.log('TaskFilterComponent toggleCompletedFilter()', change);}
    this.enableCompletedRange = !this.enableCompletedRange;
    if (change.checked===false) {
      this.data.completedMin = undefined;
      this.data.completedMax = undefined;
    }
  }

  cancel(): void {
    if (DEBUG) {console.log('TaskFilterComponent onCancel()');}
    this.dialogRef.close();
  }

  reset(): void {
    if (DEBUG) {console.log('TaskFilterComponent onReset()');}
    this.form.reset(this.resetData);
  }

}
